export function validateCategoryRules(source) {
  if (!source) return [];
  const parts = source.parts || [];
  const issues = [];

  if (source.category === 'wardrobe' || source.category === 'kitchen_cabinet') {
    const body = parts.find((p) => p.partType === 'body');
    const facades = parts.filter((p) => p.partType === 'facades' || p.partType === 'door');
    if (body && facades.length > 0) {
      const sumW = facades.reduce((acc, p) => acc + Number(p.localBox?.w || 0), 0);
      const bw = Number(body.localBox?.w || 0);
      if (Math.abs(sumW - bw) > 0.5) {
        issues.push({
          level: 'warn',
          code: 'facade_width_mismatch',
          message: 'Суммарная ширина фасадов отличается от ширины корпуса',
        });
      }
    }
  }

  if (source.category === 'bed') {
    const frame = parts.find((p) => p.partType === 'frame');
    const mattress = parts.find((p) => p.partType === 'mattress');
    if (frame && mattress) {
      const fw = Number(frame.localBox?.w || 0);
      const fd = Number(frame.localBox?.d || 0);
      const mw = Number(mattress.localBox?.w || 0);
      const md = Number(mattress.localBox?.d || 0);
      if (mw > fw || md > fd) {
        issues.push({
          level: 'hard',
          code: 'mattress_out_of_frame',
          message: 'Матрац больше внутреннего пространства каркаса',
        });
      }
    }
  }

  return issues;
}
